import { leitnerClient } from "./apiClient";

const getWordLearningListByLangApi = async (data, paginate) => {
  return await leitnerClient.post(
    `/api/v1/leitner/getWordLearningListByLang?limit=${paginate.perPage || 50}&page=${paginate.page || 1}`,
    data
  );
};

const getReadyWordLearningListByLangApi = async (data, paginate) => {
  return await leitnerClient.post(
    `/api/v1/leitner/getReadyWordLearningListByLang?limit=${paginate.perPage || 50}&page=${paginate.page || 1}`,
    data
  );
};

const addBoxApi = async (data) => {
  return await leitnerClient.post("/api/v1/leitner/addBox", data);
};

const addCardsFromSaveWordsApi = async (data) => {
  return await leitnerClient.post("/api/v1/leitner/addCardsFromSaveWords", data);
};

const getBoxesListApi = async (data) => {
  return await leitnerClient.post("/api/v1/leitner/BoxesList", data);
};

const showDetailsBox = async (data, paginate) => {
  return await leitnerClient.post(
    `/api/v1/leitner/showDetailsBox?limit=${paginate.perPage || 50}&page=${paginate.page || 1}`,
    data
  );
};

const answerCardApi = async (data) => {
  return await leitnerClient.patch("/api/v1/leitner/answerCard", data);
};

const editBoxApi = async (data) => {
  return await leitnerClient.patch("/api/v1/leitner/editBox", data);
};

const editCardApi = async (data) => {
  return await leitnerClient.patch("/api/v1/leitner/editCard", data);
};

const deleteCardApi = async (dataObject) => {
  return await leitnerClient.delete("/api/v1/leitner/deleteCard", {
    data: dataObject,
  });
};

const deleteBoxApi = async (dataObject) => {
  return await leitnerClient.delete("/api/v1/leitner/deleteBox", {
    data: dataObject,
  });
};

export {
  getWordLearningListByLangApi,
  getReadyWordLearningListByLangApi,
  addBoxApi,
  addCardsFromSaveWordsApi,
  getBoxesListApi,
  showDetailsBox,
  answerCardApi,
  editBoxApi,
  deleteBoxApi,
  editCardApi,
  deleteCardApi,
};
